import { Component, OnInit, inject } from '@angular/core'
import { LoadingStateService } from 'src/app/services/app-loading-state.service'
import { LoadingState } from 'src/app/types/loading-state'

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
    private loadingStateService = inject(LoadingStateService)

    ngOnInit() {
        this.loadingStateService.setLoadingState(LoadingState.Loaded)
    }
}
